/**
 * Types for agent binary download/distribution.
 *
 * Sprint: 73, Task: S73-B01
 */

export interface AgentBinaryInfo {
  binary_name: string;
  os: string;
  arch: string;
  size_bytes: number;
  sha256: string;
  download_url?: string;
}

export interface AgentReleaseInfo {
  version: string;
  binaries: AgentBinaryInfo[];
  has_checksums: boolean;
  created_at: string;
  download_base_url?: string;
}

export interface AgentLatestVersion {
  version: string;
  created_at?: string;
  download_base_url?: string;
}

/** OS tab identifiers */
export type AgentOS = 'darwin' | 'linux' | 'windows';

/** OS display labels */
export const OS_LABELS: Record<AgentOS, string> = {
  darwin: 'macOS',
  linux: 'Linux',
  windows: 'Windows',
};

/** Architecture display labels */
export const ARCH_LABELS: Record<string, string> = {
  arm64: 'Apple Silicon (arm64)',
  amd64: 'Intel (amd64)',
};

export const LINUX_ARCH_LABELS: Record<string, string> = {
  arm64: 'ARM64 (aarch64)',
  amd64: 'x86_64 (amd64)',
};
